import React from 'react';
import './WhyUs.css';
import focused from '../images/WhyUs/focused.png';
import precise from '../images/WhyUs/precise.png';
import adaptive from '../images/WhyUs/adaptive.png';

const WhyUs = () => {
  return (
    <section className="why-us" id="about">
      <div className="container">
        <h2 className="section-title">Why We're The Best Hunters In The Digital Marketing Jungle</h2>
        <div className="why-us-grid">
          <div className="why-us-card">
            <div className="card-icon">
              <div className="icon-wrapper quality">
                <img src={focused} alt="Focused" />
              </div>
            </div>
            <h3>Focused</h3>
            <p>
            Your brand deserves our undivided attention. In order to ensure the quality of our works, we only accept a limited number of clientele. It's not about how many clients we have, it's about how we provide the right digital marketing solutions for your business.
            </p>
          </div>
          
          <div className="why-us-card">
            <div className="card-icon">
              <div className="icon-wrapper passion">
                <img src={precise} alt="Precise" />
              </div>
            </div>
            <h3>Precise</h3>
            <p>
            We are a results-driven digital marketing agency. Here at Hunter, we believe numbers don't lie. With strategies backed by data, we make sure your business goals are met with more than 100% achievement rate.
            </p>
          </div>
          
          <div className="why-us-card">
            <div className="card-icon">
              <div className="icon-wrapper design">
                <img src={adaptive} alt="Adaptive" />
              </div>
            </div>
            <h3>Adaptive</h3>
            <p>
            Your brand is unique, and here at Hunter, so are your digital marketing strategies. Solutions are not a one-size-fits-all matter. We want to know how exactly your business is struggling, so we can tailor-fit our services according to your specific needs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;